import React from 'react'

import { useSelected } from 'slate-react'

import { bemJoin } from '@app/lib/bem'
import { ElementRenderProps, PlaceholderElement } from '@app/lib/inputs/RichEditor/types'
import './Placeholder.scss'

const b = bemJoin('placeholder')

export const Placeholder = ({
  attributes,
  element,
  children
}: ElementRenderProps<PlaceholderElement>) => {
  const selected = useSelected()

  return (
    <span
      className={b({
        selected
      })}
      {...attributes}
      data-parameter-name={element.parameterName}
    >
      {children}
      {element.placeholderText}
    </span>
  )
}
